/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React     from 'react';
import styles    from 'components/StatusIndicator/StatusIndicator.scss';

const StatusIndicator = ({ color, status, loading }) => {
  const classess = [styles.status, styles[color || 'blue']];

  if(loading) {
    classess.push(styles.loading);
  }

  return (
    <div className={classess.join(' ')}>
      <div className={styles.dot}>
        <span />
      </div>
      {status}
    </div>
  );
}


export default StatusIndicator;